<div class="handover-images" *ngIf="this.isHOLOC">
  <div class="top">
      <h2>Imágenes de Cabezal</h2>

      <div clas="count">{{wellheadImages.length + '/' + imageLimit + ' imágenes'}}
          <br />
          <mat-hint class="alert"   *ngIf="wellheadImages.length < qtyImageRequired && qtyImageRequired >= 2">
            Es obligatorio adjuntar al menos {{qtyImageRequired}} imágenes.</mat-hint
            >
            <mat-hint class="alert"   *ngIf="wellheadImages.length < qtyImageRequired && qtyImageRequired == 1">
                Es obligatorio adjuntar al menos {{qtyImageRequired}} imagen.</mat-hint
                >
  
      </div>

      <div class="attach" *ngIf="wellheadImages.length < imageLimit">
          <button mat-button [disabled]="readOnlyContent" (click)="attachImage()">
    <mat-icon class="material-icons-outlined">file_upload</mat-icon>Adjuntar foto o diagrama
  </button><br>
          <span>Archivos PNG, JPG están permitidos</span>
      </div>
  </div>

  <div class="grid">
      <div class="image" *ngFor="let image of wellheadImages.slice(0,3); index as i; first as isFirst">
          <div class="actions">
              <div class="button">
                  <button mat-icon-button *ngIf="!readOnlyContent" (click)="deleteImage(image, i)">
                      <mat-icon class="material-icons-outlined">delete</mat-icon>
                  </button> &nbsp;
                  <span class="legend" *ngIf="!readOnlyContent">Eliminar</span>
              </div>
              <div class="button">
                  <span class="legend">Ampliar</span>&nbsp;
                  <button mat-icon-button (click)="openImage(image)">
                      <mat-icon class="material-icons-outlined">open_in_full</mat-icon>
                  </button>
              </div>
          </div>
          <img src="{{dhoApiUrl}}/{{image.imagePath}}" alt="{{image.imageDescription}}" />
          <div class="description" *ngIf="image.imageDescription">
              {{image.imageDescription}}
          </div>
      </div>
  </div>
  <div class="grid">
      <div class="image" *ngFor="let image of wellheadImages.slice(3,6); index as i; first as isFirst">
          <div class="actions">
              <div class="button">
                  <button mat-icon-button *ngIf="!readOnlyContent" (click)="deleteImage(image, i)">
                      <mat-icon class="material-icons-outlined">delete</mat-icon>
                  </button> &nbsp;
                  <span class="legend" *ngIf="!readOnlyContent">Eliminar</span>
              </div>
              <div class="button">
                  <span class="legend">Ampliar</span>&nbsp;
                  <button mat-icon-button (click)="openImage(image)">
                      <mat-icon class="material-icons-outlined">open_in_full</mat-icon>
                  </button>
              </div>
          </div>
          <img src="{{dhoApiUrl}}/{{image.imagePath}}" alt="{{image.imageDescription}}" />
          <div class="description" *ngIf="image.imageDescription">
              {{image.imageDescription}}
          </div>
      </div>
  </div>
</div>